<template>
  <transition name="fade">
    <div v-if="showModal">

      <div class="ix-modal__large" v-if="largeSize==true">
        <button class="ix-modal__close" type="button" @click='toggleModal(false)' name="button"><span class="fa fa-times"></span></button>
        <div class="ix-modal__content" >
          
          <component :is="currentModalView" ></component>
        </div>
      </div>


      <div class="ix-modal__small" v-if="mobile==true & largeSize==false">
        <button class="ix-modal__close" type="button" @click='toggleModal(false)' name="button"><span class="fa fa-times"></span></button>
        <div class="ix-modal__content" >
          
          <component :is="currentModalView" ></component>
        </div>
      </div>

      <div class="ix-modal" v-if="mobile==false & largeSize==false">
        <button class="ix-modal__close" type="button" @click='toggleModal(false)' name="button"><span class="fa fa-times"></span></button>
        <div class="ix-modal__content" >
          
          <component :is="currentModalView" ></component>
        </div>
      </div>
    </div>
  </transition>

</template>


<script>

import {mapState, mapActions} from 'vuex'
//src\assets\stylesheets\components\_modal.sass
// List here all components that can be shown in modal
import CarForm from '@/views/configuration/CarForm'
import AddDeviceForm from '@/views/configuration/AddDeviceForm'
import BindingCode from '@/views/configuration/BindingCode'
import ErrorView from '@/views/shared/ErrorView'

//RETRAIT STRIPE
//import StripePaiement from '@/views/profile/StripePaiment'
//import ModifyStripePaiement from '@/views/profile/ModifyStripePaiment'

import ConfigChannel from '@/views/configuration/ConfigChannel'
import OrganizationAddForm from '@/views/profile/OrganizationAddForm'
import ChannelCommentAddForm from '@/views/measurements/SubComponents/ChannelCommentAddForm'
import ChannelMaintenanceAddForm from '@/views/measurements/SubComponents/ChannelMaintenanceAddForm'
import ConfigAccessRulesForm from '@/components/ConfigAccessRulesForm'
import EditAccessRulesForm from '@/components/EditAccessRulesForm'
import TransmitHelpRequestForm from '@/views/help/TransmitHelpRequestForm'
import ChannelCloudLiveModalDisplay from '@/views/measurements/SubComponents/ChannelCloudLiveModalDisplay'

import OrganizationApiAddMasterKeyForm from '@/views/profile/OrganizationApiAddMasterKeyForm'
import OrganizationApiChannelTemplateAddForm from '@/views/profile/OrganizationApiChannelTemplateAddForm'
import OrganizationApiDeviceTemplateAddForm from '@/views/profile/OrganizationApiDeviceTemplateAddForm'
import OrganizationApiSignalsSetAddForm from '@/views/profile/OrganizationApiSignalsSetAddForm'
import OrganizationApiAddPictureForm from '@/views/profile/OrganizationApiAddPictureForm'
import DashboardNews from '@/views/profile/DashboardNews'

export default {
  components: {
    CarForm,
    ErrorView,
    BindingCode,
    AddDeviceForm,
    ////RETRAIT STRIPE
    //StripePaiement,
    //ModifyStripePaiement,
    ConfigChannel,
    OrganizationAddForm,
    ChannelCommentAddForm,
    ChannelMaintenanceAddForm,
    ConfigAccessRulesForm,
    EditAccessRulesForm,
    TransmitHelpRequestForm,
    ChannelCloudLiveModalDisplay,
    OrganizationApiAddMasterKeyForm,
    OrganizationApiChannelTemplateAddForm,
    OrganizationApiSignalsSetAddForm,
    OrganizationApiDeviceTemplateAddForm,
    OrganizationApiAddPictureForm,
    DashboardNews
  },
  data(){
    return {
    mobile : false,
    largeSize : false,
    }
  },

  computed: {
    ...mapState('overlayStore', ['showModal', 'currentModalView','overlayParameters']),
  },
  watch: {
    showModal(){
      this.mobile = window.innerWidth <= 900
      this.largeSize = window.innerWidth >= 1200
    },
  },
  methods: {
    ...mapActions('overlayStore', ['toggleModal'])
  },
  mounted() {
    //do something after mounting vue instance
    //console.log('------Overlay parameters-----')
    //console.log(this.overlayParameters)

    this.mobile = window.innerWidth <= 900
    this.largeSize = window.innerWidth >= 1200


    //console.log('Size')
    //console.log(window.innerWidth)
  }
}
</script>



// WEBPACK FOOTER //
// Modal.vue?2e3c3048